import React, { useState } from "react";
import { getCategories } from "API/swesum";
import MainLayout1 from "Components/UI/Layout/MainLayout1";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Paper from "Components/UI/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Tab, Tabs } from "@mui/material";

import { useNavigate, useLoaderData } from "react-router-dom";
import { createOption } from "API/swesum";
import usePost from "Hooks/usePost";
import OptionForm from "Components/Option/OptionForm";
import OptionFormSystem from "./option/OptionFormSystem";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export async function loader() {
  const categories = await getCategories();
  return { categories };
}

const initialState = {
  Name: "",
  Value: "",
  Category: "",
  SystemStatus: "",
};

export function CreateOption() {
  const [formData, setFormData] = useState(initialState);
  const { categories } = useLoaderData();
  const { openError } = usePopupNotificationContext();

  const createOptionReq = usePost({
    mtnFunc: (body) => createOption(body),
    onError: () => {
      openError("Ett fel uppstod när Kontot skapades.");
    },
    onSuccess: () => {
      navigate("/options");
    },
  });

  const navigate = useNavigate();

  const handleInputChange = (field, newVal) => {
    setFormData({ ...formData, [field]: newVal });
  };

  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <MainLayout1>
        <Container sx={{ flexGrow: 1, pt: 5 }}>
          <Paper>
            {" "}
            <Typography sx={{ marginBottom: "2rem" }} variant="h5">
              Skapa inställning
            </Typography>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Allmänt" />
              <Tab label="System" />
            </Tabs>
            <TabPanel value={tabIndex} index={0}>
              <OptionForm
                formData={formData}
                categories={categories}
                handleInputChange={handleInputChange}
              />
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <OptionFormSystem
                formData={formData}
                handleInputChange={handleInputChange}
              />
            </TabPanel>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)} sx={{ mt: 5 }}>
                Stäng
              </Button>
              <Button
                onClick={() => createOptionReq.post(formData)}
                variant="contained"
                sx={{ ml: 3, mt: 5 }}
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Container>
      </MainLayout1>
    </>
  );
}
